import ExpandedSection from './ExpandedSection';
import type { CannabinoidDisplayMode, CannabinoidRow } from './RetailIdExpandedDesignPage';
import { toTestIdPart } from '../../utils/testIds';
import './cannabinoidsSection.css';

type CannabinoidsSectionProps = {
  chevronSrc: string;
  rows: CannabinoidRow[];
  displayMode: CannabinoidDisplayMode;
};

export default function CannabinoidsSection({ chevronSrc, rows, displayMode }: CannabinoidsSectionProps) {
  const showWeightContexts = displayMode === 'Weight';
  const showWeight = displayMode === 'Both';
  const hasOutcomes = rows?.some(row => row?.outcomeText !== undefined);
  const hasWeightModeResults = showWeightContexts && rows?.some(row => row?.weightModeResultText !== undefined);
  const showResult = hasOutcomes || hasWeightModeResults;
  const showPercent = showResult || displayMode === 'Both' || displayMode === 'Percent';

  return (
    <ExpandedSection title="Cannabinoids" chevronSrc={chevronSrc} testId="landing-cannabinoids-toggle">
      <div className="rid-cannabinoids__table-scroll">
        <table
          className={`rid-cannabinoids__table ${showWeightContexts ? 'rid-cannabinoids__table--weight' : ''}`}
          aria-label="Cannabinoid measurements"
          data-testid="landing-cannabinoids-table"
          data-display-mode={displayMode}
        >
          <thead>
            <tr>
              <th scope="col" data-testid="landing-cannabinoids-header-name">Cannabinoid</th>
              {showWeightContexts ? <th scope="col" className="rid-cannabinoids__value" data-testid="landing-cannabinoids-header-per-serving">Per Serving</th> : null}
              {showWeightContexts ? <th scope="col" className="rid-cannabinoids__value" data-testid="landing-cannabinoids-header-per-package">Per Package</th> : null}
              {showWeight ? <th scope="col" className="rid-cannabinoids__value" data-testid="landing-cannabinoids-header-weight">Weight</th> : null}
              {showPercent ? <th scope="col" className="rid-cannabinoids__value" data-testid="landing-cannabinoids-header-percent">{showResult ? 'Result' : 'Percent'}</th> : null}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const rowId = toTestIdPart(row.cannabinoid, 'cannabinoid');
              return (
                <tr
                  key={row.cannabinoid}
                  className={row.emphasized ? 'rid-cannabinoids__row-emphasis' : ''}
                  data-testid={`landing-cannabinoid-row-${rowId}`}
                >
                  <td data-testid={`landing-cannabinoid-name-${rowId}`}>{row.cannabinoid}</td>
                  {showWeightContexts ? <td className="rid-cannabinoids__value" data-testid={`landing-cannabinoid-per-serving-${rowId}`}>{row.perServing}</td> : null}
                  {showWeightContexts ? <td className="rid-cannabinoids__value" data-testid={`landing-cannabinoid-per-package-${rowId}`}>{row.perPackage}</td> : null}
                  {showWeight ? <td className="rid-cannabinoids__value" data-testid={`landing-cannabinoid-weight-${rowId}`}>{row.weight}</td> : null}
                  {showPercent ? <td className="rid-cannabinoids__value" data-testid={`landing-cannabinoid-percent-${rowId}`}>{(showWeightContexts ? row.weightModeResultText : undefined) ?? row.outcomeText ?? (showWeightContexts ? '' : row.percent)}</td> : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </ExpandedSection>
  );
}
